import { LiveData, Service } from '@toeverything/infra';
import type { Observable } from 'rxjs';

import type { WorkspaceService } from '../../workspace';
import { WorkspaceQuota } from '../entities/quota';
import {
  isWorkspaceStorageFull,
  type WorkspaceSyncFailures,
} from '../storage-full';

export class WorkspaceQuotaService extends Service {
  quota = this.framework.createEntity(WorkspaceQuota);

  /**
   * The cloud workspace has no free storage. Its changes stay on this device
   * and sync resumes once there is room again; a local workspace never fills.
   */
  readonly storageFull$: LiveData<boolean>;

  constructor(workspaceService: WorkspaceService) {
    super();
    const workspace = workspaceService.workspace;
    if (workspace.flavour === 'local') {
      this.storageFull$ = new LiveData(false);
      return;
    }
    const syncFailures$ = LiveData.from<WorkspaceSyncFailures | null>(
      workspace.engine.doc.state$ as Observable<WorkspaceSyncFailures>,
      null
    );
    this.storageFull$ = LiveData.computed(get =>
      isWorkspaceStorageFull(get(this.quota.percent$), get(syncFailures$))
    );
  }

  override dispose(): void {
    this.quota.dispose();
  }
}
